import React from 'react';
import Hero from '../components/Hero';
import HeroQuote from '../components/HeroQuote';
import AboutUs from '../components/AboutUs';
import Services from '../components/Services';
import Team from '../components/Team';
import Testimonials from '../components/Testimonials';
import FAQs from '../components/FAQs';

const Home = () => {
  return (
    <>
      <Hero />
      <HeroQuote />
      <AboutUs />
      <Services />
      <Team />
      <Testimonials />
      <FAQs />
    </>
  );
};

export default Home;

